import React from 'react'
import type { CSSProperties } from 'react'

import { HandcuffIcon, LightningIcon } from './icons'

export type InvFilter = 'all' | 'auto' | 'manual'

interface Props {
  filter: InvFilter
  setFilter: (filter: InvFilter) => void
  hiddenCount: number
}

const chipBase: CSSProperties = {
  padding: '4px 10px',
  borderRadius: 12,
  fontSize: 11,
  cursor: 'pointer',
  fontFamily: 'inherit',
}

export const FilterBar: React.FunctionComponent<Props> = (props) => {
  const { filter, setFilter, hiddenCount } = props

  return (
    <div
      className="inv-filter-bar"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 16px 12px',
        fontSize: 12,
      }}
    >
      <span
        style={{
          color: '#86868b',
          fontWeight: 500,
          textTransform: 'uppercase',
          letterSpacing: '0.4px',
          fontSize: 11,
        }}
      >
        Show:
      </span>
      <button
        type="button"
        className={`inv-filter-chip${filter === 'all' ? ' active' : ''}`}
        onClick={() => setFilter('all')}
        style={{
          ...chipBase,
          background: filter === 'all' ? '#1d1d1f' : 'white',
          color: filter === 'all' ? 'white' : '#475569',
          border: `1px solid ${filter === 'all' ? '#1d1d1f' : '#e2e8f0'}`,
        }}
      >
        All
      </button>
      <button
        type="button"
        className={`inv-filter-chip${filter === 'auto' ? ' active' : ''}`}
        onClick={() => setFilter('auto')}
        style={{
          ...chipBase,
          background: filter === 'auto' ? '#1d1d1f' : 'white',
          color: filter === 'auto' ? 'white' : '#475569',
          border: `1px solid ${filter === 'auto' ? '#1d1d1f' : '#e2e8f0'}`,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <LightningIcon />
        Auto
      </button>
      <button
        type="button"
        className={`inv-filter-chip${filter === 'manual' ? ' active' : ''}`}
        onClick={() => setFilter('manual')}
        style={{
          ...chipBase,
          background: filter === 'manual' ? '#1d1d1f' : 'white',
          color: filter === 'manual' ? 'white' : '#475569',
          border: `1px solid ${filter === 'manual' ? '#1d1d1f' : '#e2e8f0'}`,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <HandcuffIcon />
        Manual
      </button>
      {filter !== 'all' && hiddenCount > 0 ? (
        <span
          className="inv-filter-hint"
          style={{
            marginLeft: 'auto',
            fontSize: 11,
            color: '#94a3b8',
            fontStyle: 'italic',
          }}
        >
          {hiddenCount} hidden
        </span>
      ) : null}
    </div>
  )
}
